/**
 * Minimum lead time for scheduling a post. The publish-sweep cron runs every
 * 10 minutes and platforms need their own lead time, so anything sooner risks
 * being missed by the scheduler. Scheduled times must be at least this far out.
 */
export const MIN_SCHEDULE_LEAD_MINUTES = 15;
export const MIN_SCHEDULE_LEAD_MS = MIN_SCHEDULE_LEAD_MINUTES * 60_000;

/** The earliest valid scheduled instant (ms epoch) relative to `now`. */
export function earliestScheduleMs(now: number = Date.now()): number {
  return now + MIN_SCHEDULE_LEAD_MS;
}
